import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { storage } from "../../services/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Field, Label } from "../../components/catalyst/fieldset";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import { toast } from "react-toastify";

function PanelNotairePhoto() {
  const context = useNotaire();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUploadPhoto = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const fileSize = selectedFile.size / 1024 ** 2;
    if (fileSize >= 2) {
      toast.error("📦 Le fichier dépasse 2 Mo.");
      event.target.value = "";
      return;
    }

    setLoading(true);

    try {
      const storageRef = ref(storage, selectedFile.name);
      await uploadBytes(storageRef, selectedFile);

      const url = await getDownloadURL(storageRef);
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);

      const response = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fields: {
              photo_profil: [{ url, filename: selectedFile.name }],
            },
          }),
        }
      );

      if (response.ok) {
        toast.success("Photo mise à jour !");
      } else {
        const err = await response.text();
        console.error("Airtable error:", err);
        toast.error("Erreur lors de la mise à jour.");
      }
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Erreur d’upload ou de mise à jour.");
    } finally {
      setLoading(false);
    }
  };

  const photoUrl = preview
    || (context.infoNotaire.photo_profil && context.infoNotaire.photo_profil[0]?.url)
    || null;

  return (
    <div className="bg-white p-6 rounded shadow mt-8">
      <Field>
        <Label>Photo de profil</Label>
        <p className="text-sm text-gray-600 mb-2">
          👋 Les profils avec photo sont toujours plus engageants.
        </p>
        <div className="flex items-center gap-4">
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Photo de profil"
              className="h-14 w-14 rounded-full object-cover"
            />
          ) : (
            <UserCircleIcon className="h-12 w-12 text-gray-300" />
          )}
          <input
            type="file"
            accept="image/png, image/jpeg"
            onChange={handleUploadPhoto}
            disabled={loading}
          />
        </div>
      </Field>
    </div>
  );
}

export default PanelNotairePhoto;